export const appUserAuthTypes = {
  REQUEST_OTP_REQUEST: 'APP_USER_REQUEST_OTP_REQUEST',
  REQUEST_OTP_SUCCESS: 'APP_USER_REQUEST_OTP_SUCCESS',
  REQUEST_OTP_FAILURE: 'APP_USER_REQUEST_OTP_FAILURE',
  VERIFY_OTP_REQUEST: 'APP_USER_VERIFY_OTP_REQUEST',
  VERIFY_OTP_SUCCESS: 'APP_USER_VERIFY_OTP_SUCCESS',
  VERIFY_OTP_FAILURE: 'APP_USER_VERIFY_OTP_FAILURE',
  FETCH_TENANTS_REQUEST: 'APP_USER_FETCH_TENANTS_REQUEST',
  FETCH_TENANTS_SUCCESS: 'APP_USER_FETCH_TENANTS_SUCCESS',
  FETCH_TENANTS_FAILURE: 'APP_USER_FETCH_TENANTS_FAILURE',
  REQUEST_TENANT_REDIRECT_REQUEST: 'APP_USER_REQUEST_TENANT_REDIRECT_REQUEST',
  REQUEST_TENANT_REDIRECT_SUCCESS: 'APP_USER_REQUEST_TENANT_REDIRECT_SUCCESS',
  REQUEST_TENANT_REDIRECT_FAILURE: 'APP_USER_REQUEST_TENANT_REDIRECT_FAILURE',
  CHANGE_EMAIL: 'APP_USER_CHANGE_EMAIL',
  SET_ALERT: 'APP_USER_SET_ALERT',
  CLEAR_ALERT: 'APP_USER_CLEAR_ALERT'
};

export const requestOtp = email => ({
  type: appUserAuthTypes.REQUEST_OTP_REQUEST,
  email
});

export const verifyOtp = (email, otp) => ({
  type: appUserAuthTypes.VERIFY_OTP_REQUEST,
  email,
  otp
});

export const fetchTenants = () => ({
  type: appUserAuthTypes.FETCH_TENANTS_REQUEST
});

export const requestTenantRedirect = subdomain => ({
  type: appUserAuthTypes.REQUEST_TENANT_REDIRECT_REQUEST,
  subdomain
});

// Return to the email step (e.g. "Cambiar correo" / "Cancelar"). Keeps the
// typed email so it stays prefilled; clears the OTP/tenant progress.
export const changeEmail = () => ({
  type: appUserAuthTypes.CHANGE_EMAIL
});

// Show a message in the login alert banner ({ kind, message }). Used e.g. to
// surface the ?reason= a monolith auth failure forwarded to this SPA.
export const setLoginAlert = alert => ({
  type: appUserAuthTypes.SET_ALERT,
  alert
});

// Dismiss the login alert banner.
export const clearLoginAlert = () => ({
  type: appUserAuthTypes.CLEAR_ALERT
});
